import React from 'react'
import logo from '../images/large_tree_logo.png'
import PageviewGA from '../components/pageview-ga'


export default class extends React.Component {
    render() {
        return (
            <div id="main_content" style={{textAlign: "center"}} className="flex layout-column scrollable layout-align-center">
                <PageviewGA/>
                <img alt="morrisons logo" height="200" src={logo}></img>
                <h1 style={{fontWeight: "normal", color: "#004E37", fontSize: "2em"}}>My Pay</h1>
                <div style={{padding: "10px"}}></div>
                <div style={{color: "red"}}>You are not authorised to use this application</div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/login_not_authorised.js